import { render, staticRenderFns } from "./DirectorInfo.vue?vue&type=template&id=c9d236b6&scoped=true"
import script from "./DirectorInfo.vue?vue&type=script&lang=js"
export * from "./DirectorInfo.vue?vue&type=script&lang=js"
import style0 from "./DirectorInfo.vue?vue&type=style&index=0&id=c9d236b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9d236b6",
  null
  
)

export default component.exports